import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Box, Paper, Button, useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const ReportFilterFallback: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation('ReportsFallback');

  return (
    <Box display="flex" justifyContent="center" alignItems="center" p={4}>
      <Box
        component={Paper}
        p={3}
        display="grid"
        gridGap={theme.spacing(2)}
        textAlign="center"
        gridTemplateAreas="1fr"
      >
        <Typography variant="h1">{t('Oops!')}</Typography>
        <Typography variant="body1">
          {t('Something wrong happened generating the report. Please try again.')}
        </Typography>
        <Box>
          <Button variant="contained" color="primary" disableElevation href={'/reports'}>
            {t('Try Again')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ReportFilterFallback;
